import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import CosmicBackground from "@/components/CosmicBackground";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Projects from "@/pages/Projects";
import Gallery from "@/pages/Gallery";
import Testimonials from "@/pages/Testimonials";
import Horoscope from "@/pages/Horoscope";
import Numerology from "@/pages/Numerology";
import FAQ from "@/pages/FAQ";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import Contact from "@/pages/Contact";
import ProjectDetail from "@/pages/ProjectDetail";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  const lenis = useLenis();
  useEffect(() => {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, lenis]);
  return null;
}

function SiteLayout({ children }) {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
      <WhatsAppButton />
    </>
  );
}

function App() {
  return (
    <div className="App grain">
      <CosmicBackground />
      <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
        <BrowserRouter>
          <AuthProvider>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<SiteLayout><Home /></SiteLayout>} />
              <Route path="/about" element={<SiteLayout><About /></SiteLayout>} />
              <Route path="/services" element={<SiteLayout><Services /></SiteLayout>} />
              <Route path="/projects" element={<SiteLayout><Projects /></SiteLayout>} />
              <Route path="/projects/:id" element={<SiteLayout><ProjectDetail /></SiteLayout>} />
              <Route path="/gallery" element={<SiteLayout><Gallery /></SiteLayout>} />
              <Route path="/testimonials" element={<SiteLayout><Testimonials /></SiteLayout>} />
              <Route path="/horoscope" element={<SiteLayout><Horoscope /></SiteLayout>} />
              <Route path="/numerology" element={<SiteLayout><Numerology /></SiteLayout>} />
              <Route path="/faq" element={<SiteLayout><FAQ /></SiteLayout>} />
              <Route path="/blog" element={<SiteLayout><Blog /></SiteLayout>} />
              <Route path="/blog/:slug" element={<SiteLayout><BlogDetail /></SiteLayout>} />
              <Route path="/contact" element={<SiteLayout><Contact /></SiteLayout>} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
            </Routes>
            <Toaster position="top-center" richColors />
          </AuthProvider>
        </BrowserRouter>
      </ReactLenis>
    </div>
  );
}

export default App;
